let domain = undefined;
export const setDomain = (_domain) => {
    domain = _domain;
};
const useDomain = () => {
    return domain;
};
export default useDomain;
